module.exports = __webpack_public_path__ + "static/media/Wesley.e4a1cdff.md";